





























import Vue from 'vue';

export default Vue.extend({
  auth: true,
  data: () => ({
  }),
  beforeMount(){
    // Remove this redirect in case there is more 
    // than one option to select from in the overview
    // At the moment it just doesn't make sense to show 
    // a single option that the user has to click again
    this.$router.replace('/syna/memberPortal/invoice/invoice-summary');
  },
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
  },
  mounted() {
  },

});
